import { z } from 'zod';

const SourceSchema = z.object({
  file: z.string().min(1),
  line: z.number().int().optional()
}).optional();

export const FieldDefinitionSchema = z.object({
  name: z.string().min(1),
  type: z.string().min(1),
  optional: z.boolean(),
  array: z.boolean().optional(),
  description: z.string().optional(),
  source: SourceSchema
});

export type FieldDefinition = z.infer<typeof FieldDefinitionSchema>;
